<template>
    <div class="flex flex-col grow">
        <DocumentViewerToolbar></DocumentViewerToolbar>
        <div class="relative flex flex-row grow h-full">
            <div class="overflow-hidden w-full document-viewer-container mt-4">
                <div class="fluid container">
                    <!-- Xandr Ads -->
                    <DocumentShowXandrAds
                        v-if="pdfViewerInitialized"
                        class="mb-3"
                        :xandr-properties="getAdProperties('_btf')"
                    ></DocumentShowXandrAds>
                    <DocumentViewer ref="viewer" />
                    <!-- Xandr Ads -->
                    <DocumentShowXandrAds
                        v-if="pdfViewerInitialized"
                        class="mt-3"
                        :xandr-properties="getAdProperties('_btf_2')"
                    ></DocumentShowXandrAds>
                </div>
                <div class="container my-5 lg:my-10">
                    <div
                        v-if="!document.user_is_uploader"
                        class="rounded bg-white flex flex-col items-center shadow p-5 md:p-6 mt-5"
                    >
                        <h3 class="text-center mb-3 text-2xl font-medium">
                            {{ $t('document:show.send_love_title') }}
                        </h3>
                        <BtnRateDocument
                            :user-vote="document.user_star_vote"
                            :avg-score="document.avg_star_score"
                            :ratings-count="document.ratings_count"
                            :document-id="document.id"
                            size="sm"
                            variant="outlined"
                            :disabled="document.user_is_uploader"
                            @update:user-vote="$store.commit('document/UPDATE_DOCUMENT_USER_STAR_VOTE', $event)"
                            @update:avg-score="$store.commit('document/UPDATE_DOCUMENT_AVG_STAR_SCORE', $event)"
                            @update:ratings-count="$store.commit('document/UPDATE_DOCUMENT_RATINGS_COUNT', $event)"
                        />
                    </div>
                    <TheFooterStatic
                        v-show="screen.minLG"
                        class="mt-10"
                    />
                </div>
            </div>

            <DocumentShowDiscussion
                ref="discussion"
                :document-id="document.id"
                :document-infected="document.infected"
            ></DocumentShowDiscussion>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import DocumentShowXandrAds from '@/components/DocumentShowXandrAds/DocumentShowXandrAds.vue';
import BtnRateDocument from '@/components/BtnRateDocument';
import TheFooterStatic from '@components/TheFooterStatic';
import DocumentViewerToolbar from './DocumentPDFViewerToolbar.vue';

export default {
    name: 'DocumentShowDocument',
    components: {
        DocumentViewerToolbar,
        DocumentViewer: defineAsyncComponent(() => import('./DocumentPDFViewer.vue')),
        DocumentShowDiscussion: defineAsyncComponent(() => import('./DocumentShowDiscussion.vue')),
        DocumentShowXandrAds,
        BtnRateDocument,
        TheFooterStatic,
    },
    computed: {
        ...mapGetters({
            pdfViewerInitialized: 'document/pdfViewerInitialized',
            document: 'document/currentDocument',
            isShowingDiscussion: 'document/isShowingDiscussion',
            screen: 'ui/screen',
        }),
    },
    methods: {
        getAdProperties(btf = '') {
            const bannerType = this.screen.minMD ? 'billboard' : 'banner';
            return {
                xandrWrapper: `${bannerType}${btf}Wrapper`,
                xandrSlot: `${bannerType}${btf}`,
                adOnDemand: true,
            };
        },
    },
};
</script>
